/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Partner_Customer_Kpi_OverageInputs */



/**
* | output |
* | --- |
* | "{amount} overage" |
*
* @param {Partner_Customer_Kpi_OverageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_customer_kpi_overage = /** @type {((inputs: Partner_Customer_Kpi_OverageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Customer_Kpi_OverageInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.amount} Mehrverbrauch`)
	return /** @type {LocalizedString} */ (`${i?.amount} overage`)
});